import { useEffect, useState, useRef, useCallback } from "react";
import { WidgetConfigProvider, RemoteWidget } from "@tiktokshop/widget-kit-react";

export default function TikTokWidget() {
    const [tokenData, setTokenData] = useState(null);
    const refreshTimer = useRef(null);

    // Hàm fetch token từ backend
    const fetchToken = useCallback(async () => {
        try {
            const res = await fetch("/api/website/widget", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    outer_shop_id: "xxx",
                    partner_type: "1",
                }),
            });
            const data = await res.json();
            const widgetToken = data?.data?.widget_token;

            if (widgetToken?.token && widgetToken?.expire_at) {
                setTokenData(widgetToken);

                // setup refresh trước khi hết hạn 1 phút
                if (refreshTimer.current) clearTimeout(refreshTimer.current);
                const now = Math.floor(Date.now() / 1000);
                const ttl = widgetToken.expire_at - now;
                if (ttl > 60) {
                    refreshTimer.current = setTimeout(fetchToken, (ttl - 60) * 1000);
                }
            }
        } catch (err) {
            console.error("Fetch widget token failed:", err);
        }
    }, []);

    // Lấy token khi component mount
    useEffect(() => {
        fetchToken();
        return () => {
            if (refreshTimer.current) clearTimeout(refreshTimer.current);
        };
    }, [fetchToken]);

    // Hàm SDK gọi → luôn trả token cache
    const getToken = async () => {
        if (!tokenData) return {};
        return tokenData; // { token, expire_at }
    };

    if (!tokenData) {
        return <div>Loading widget...</div>;
    }

    return (
        <WidgetConfigProvider
            config={{
                shopId: "7496266380651629434",
                oecRegion: "US",
                appKey: "6em06b82qg1hk",
                isvInfo: { name: "OPEN_PLATFORM" },
            }}
            getToken={getToken}
            remotes={[{ name: "@tiktokshop-widget/product:optimizer" }]}
            preloadWidgetNames={["@tiktokshop-widget/product:optimizer"]}
        >
            <RemoteWidget
                name="@tiktokshop-widget/product:optimizer"
                className="containerClass"
                options={{}}
            />
        </WidgetConfigProvider>
    );
}
